import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NasModelModule } from '@sama/ng-app-state';
import { CrossTeamSharedModule } from '../cross-team-shared/cross-team-shared.module';
import { SceneCanvasComponent } from './canvas/scene-canvas.component';
import { AddRandomCuboidsComponent } from './dev-components/add-random-cuboids/add-random-cuboids.component';
import { GenerateRandomPointsComponent } from './dev-components/generate-random-points/generate-random-points.component';
import { CoordinatesControlComponent } from './dev-components/modify-asset-bounding-box/coordinates-control.component';
import { ModifyAssetBoundingBoxComponent } from './dev-components/modify-asset-bounding-box/modify-asset-bounding-box.component';
import { PointCloudContentInitializerComponent } from './point-cloud-content-initializer/point-cloud-content-initializer.component';
import { EditPanelComponent } from './renderers/edit-panel/edit-panel.component';
import { MainPointCloudRendererComponent } from './renderers/main-point-cloud/main-point-cloud-renderer.component';
import { MainViewComponent } from './renderers/main-view/main-view.component';
import { OrthographicRendererComponent } from './renderers/orthographic/orthographic-renderer.component';
import { ProjectionRendererComponent } from './renderers/projection/projection-renderer.component';
import { AutoGroundButtonComponent } from './renderers/side-view/auto-ground-button/auto-ground-button.component';
import { EditPanelToolbarComponent } from './renderers/side-view/edit-panel-toolbar/edit-panel-toolbar.component';
import { SideViewComponent } from './renderers/side-view/side-view.component';
import { SplitViewAutoGroundButtonComponent } from './renderers/side-view/split-view-auto-ground-button/split-view-auto-ground-button.component';
import { ToggleEditPanelButtonComponent } from './renderers/side-view/toggle-edit-panel-button/toggle-edit-panel-button.component';
import { PointCloudLayerViewSettingsPopoverComponent } from './toolbars/layer-settings/point-cloud-layer-view-settings-popover.component';
import { PointCloudLayerViewSettingsComponent } from './toolbars/layer-settings/point-cloud-layer-view-settings.component';
import { MainPointCloudToolbarComponent } from './toolbars/main-toolbar/main-point-cloud-toolbar.component';
import { SplitViewMainPointCloudToolbarComponent } from './toolbars/main-toolbar/split-view-main-point-cloud-toolbar.component';
import { MeasureToolbarComponent } from './toolbars/measure-toolbar/measure-toolbar.component';
import { ProjectShapesButtonComponent } from './toolbars/projection-settings-toolbar/project-shapes-button/project-shapes-button.component';
import { SecondaryToolbar3DComponent } from './toolbars/secondary-toolbar-3d/secondary-toolbar-3d.component';
import { ViewSettings3DComponent } from './toolbars/view-settings/view-settings-3d.component';
import { EditSecondaryToolbar3DComponent } from './tools/edit-tool/edit-secondary-toolbar-3d.component';
import { MeasureSecondaryToolbar3DComponent } from './tools/measure-tool/measure-secondary-toolbar.component';
import { CuboidDimensionsComponent } from './utils/rescale/cuboid-dimensions/cuboid-dimensions.component';
import { CuboidRescaleConfirmationModalComponent } from './utils/rescale/cuboid-rescale-confirmation-modal/cuboid-rescale-confirmation-modal.component';
import { CuboidRescaleModalComponent } from './utils/rescale/cuboid-rescale-modal/cuboid-rescale-modal.component';
import { SplitViewRescaleToggleComponent } from './utils/rescale/split-view-rescale-toggle/split-view-rescale-toggle.component';

const secondaryToolbars3D = [
  EditSecondaryToolbar3DComponent,
  MeasureSecondaryToolbar3DComponent,
];

// These components are published to the core team, then it places them on the
// layout
const exportedItems = [
  AddRandomCuboidsComponent,
  CoordinatesControlComponent,
  CuboidRescaleConfirmationModalComponent,
  MainPointCloudRendererComponent,
  GenerateRandomPointsComponent,
  MainPointCloudToolbarComponent,
  MeasureToolbarComponent,
  ModifyAssetBoundingBoxComponent,
  OrthographicRendererComponent,
  PointCloudContentInitializerComponent,
  PointCloudLayerViewSettingsComponent,
  PointCloudLayerViewSettingsPopoverComponent,
  ProjectionRendererComponent,
  SplitViewMainPointCloudToolbarComponent,
  ViewSettings3DComponent,
  SecondaryToolbar3DComponent,
];

@NgModule({
  imports: [
    CommonModule,
    CrossTeamSharedModule,
    FormsModule,
    FontAwesomeModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatExpansionModule,
    MatInputModule,
    MatTooltipModule,
    NasModelModule,
    MatCheckboxModule,
  ],
  exports: [exportedItems, CrossTeamSharedModule],
  declarations: [
    exportedItems,
    secondaryToolbars3D,
    CuboidDimensionsComponent,
    CuboidRescaleConfirmationModalComponent,
    CuboidRescaleModalComponent,
    MainViewComponent,
    SceneCanvasComponent,
    ProjectShapesButtonComponent,
    SideViewComponent,
    EditPanelComponent,
    EditPanelToolbarComponent,
    SplitViewRescaleToggleComponent,
    AutoGroundButtonComponent,
    SplitViewAutoGroundButtonComponent,
    ToggleEditPanelButtonComponent,
  ],
})
export class PointCloudContentModule {}
